import { authorizedFetch } from '../utils/auth'
import { checkStatus, checkInstagramStatus } from '../utils/fetch'
import {
  closeLoginModal,
  switchToForgotPasswordConfirmation,
  switchToLogin,
  updateForgotPasswordError,
  updateResetPasswordError
} from './login'
import { showInstagramEmailModal } from './instagramEmail'
import config from '../config.js'

export const OPEN_MODAL = 'OPEN_MODAL'
export const CLEAR_INVITATION = 'CLEAR_INVITATION'
export const LOGOUT = 'LOGOUT'
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
export const CHECK_ACCOUNT = 'CHECK_ACCOUNT'
export const UPDATE_INACTIVE_EVENTS = 'UPDATE_INACTIVE_EVENTS'
export const UPDATE_RECEIVE_NEWSLETTER = 'UPDATE_RECEIVE_NEWSLETTER'
export const RESET_PASSWORD_TOKEN = 'RESET_PASSWORD_TOKEN'
export const DELETE_RESET_PASSWORD_TOKEN = 'DELETE_RESET_PASSWORD_TOKEN'

export const instagramRegister = (email, token, redirect) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/instagram/register', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ email: email, token: token, redirect: redirect })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateAccount(response.data)))
    .then(response => dispatch(closeLoginModal()))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const instagramLogin = (code, redirect) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/instagram/login', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ code: code, redirect: redirect })
  })
    .then(response => response.json())
    .then(checkInstagramStatus)
    .then(response => dispatch(updateAccount(response.data)))
    .then(response => dispatch(closeLoginModal()))
    .catch(function(error) {
      dispatch(showInstagramEmailModal(error.response.data.token))
    })
}

export const facebookLogin = facebookInfo => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/facebook/login', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify(facebookInfo)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateAccount(response.data)))
    .then(response => dispatch(closeLoginModal()))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const googleLogin = googleInfo => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/google/login', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify(googleInfo)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateAccount(response.data)))
    .then(response => dispatch(closeLoginModal()))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const linkedinExchangeAuthorizationCodeForAccessToken = code => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  fetch(config.api_url + 'auth/linkedin/exchangeCodeForToken', {
    headers: headers,
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ code: code })
  })
    .then(response => response.json())
    .then(response => dispatch(linkedinLogin(response)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const linkedinLogin = linkedinInfo => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/linkedin/login', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify(linkedinInfo)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateAccount(response.data)))
    .then(response => dispatch(closeLoginModal()))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const forgotPassword = forgotInfo => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/forgotPassword', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify(forgotInfo)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => {
      if (response.error) {
        dispatch(updateForgotPasswordError(response.error))
      } else if (response.response) {
        dispatch(switchToForgotPasswordConfirmation(response.response))
      } else {
        dispatch(updateForgotPasswordError('Something went wrong. Please try again.'))
      }
    })
    .catch(function(error) {
      dispatch(updateForgotPasswordError('Something went wrong. Please try again.'))
    })
}

export const resetPassword = resetInfo => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/resetPassword', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify(resetInfo)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => {
      if (response.error) {
        dispatch(updateResetPasswordError(response.error))
      } else if (response.response) {
        dispatch(switchToForgotPasswordConfirmation(response.response))
      } else {
        dispatch(updateResetPasswordError('Something went wrong. Please try again.'))
      }
    })
    .catch(function(error) {
      dispatch(updateResetPasswordError('Something went wrong. Please try again.'))
    })
}

export const login = loginInfo => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/login', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify(loginInfo)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateAccount(response)))
    .then(response => {
      if (!(response.account && response.account.error)) {
        dispatch(closeLoginModal())
      }
    })
    .catch(function(error) {
      dispatch(logout())
    })
}

export const register = registerInfo => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/register', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify(registerInfo)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateAccount(response)))
    .then(response => {
      if (!(response.account && response.account.error)) {
        dispatch(closeLoginModal())
      }
    })
    .catch(function(error) {
      dispatch(logout())
    })
}

export const registerWithInvitation = registerWithInvitationInfo => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/registerWithInvitation', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify(registerWithInvitationInfo)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateAccount(response)))
    .then(response => {
      if (!(response.account && response.account.error)) {
        dispatch(closeLoginModal())
      }
    })
    .catch(function(error) {
      dispatch(logout())
    })
}

export const checkInvitation = invitation => dispatch => {
  if (invitation) {
    var headers = new Headers()

    headers.append('Content-Type', 'application/json')
    headers.append('Access-Control-Allow-Origin', '*')
    headers.append('Accept', 'application/json')

    authorizedFetch(config.api_url + 'auth/checkInvitation', {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: 'POST',
      body: JSON.stringify({ invitation: invitation })
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => {
        // dispatch(openModal(response.redirect, invitation))
        dispatch(openModal('invitationApp', invitation))
      })
      .catch(function(error) {
        dispatch(logout())
      })
  } else {
    dispatch(clearInvitation())
  }
}

export const checkAccountStatus = userId => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/status', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ user_id: userId })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(checkAccount(response.data)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const requireAccess = accessInfo => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'auth/requireAccess', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify(accessInfo)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateAccount(response.data)))
    .catch(function(error) {
      dispatch(logout())
    })
}

export const resendEmail = (userId, info) => dispatch => {
  var headers = new Headers()

  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'users/resend/' + userId, {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify(info)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(updateAccount(response.data)))
    .catch(function(error) {
      dispatch(logout())
    })
}
export const updateInactiveEvents = allowInactiveEvents => ({
  allowInactiveEvents,
  type: UPDATE_INACTIVE_EVENTS
})

export const updateReceiveNewsletter = allowReceiveNewsletter => ({
  allowReceiveNewsletter,
  type: UPDATE_RECEIVE_NEWSLETTER
})

export const updateAccount = account => ({
  type: UPDATE_ACCOUNT,
  account: account
})

export const checkAccount = account => ({
  type: CHECK_ACCOUNT,
  account: account
})

export const openModal = (modalToOpen, invitation) => ({
  type: OPEN_MODAL,
  modalToOpen: modalToOpen,
  invitation: invitation
})

export const clearInvitation = () => ({
  type: CLEAR_INVITATION
})

export const logout = () => ({
  type: LOGOUT
})

export const resetPasswordToken = resetPasswordIdentifier => ({
  type: RESET_PASSWORD_TOKEN,
  resetPasswordIdentifier
})

export const deleteResetPasswordToken = () => ({
  type: DELETE_RESET_PASSWORD_TOKEN
})



// WEBPACK FOOTER //
// ./src/actions/auth.js